import * as React from "react";
import { axiosWithoutAuth } from "../../axios/axiosInstance";
import { base64Encode, isValidArray } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { useAuth } from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { ViewPdfButton } from "./NewsFlyers/item/viewPdfButton";
import { ViewEbookButton } from "./NewsFlyers/item/viewEbookButton";
import { BrowseOnlineButton } from "./NewsFlyers/item/browseOnlineButton";

export const Wese_NewProductsFlyers = ({ viewBox, UserResponse, pageNo }) => {
  const itemsPerPage = 12;
  const indexOfLastItem = pageNo * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const { userId } = useAuth();

  const currentItems = UserResponse.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <div className="row">
      {isValidArray(currentItems) &&
        currentItems.map((item) =>
          viewBox === "grid" ? (
            <div className="col-6 col-md-4 col-lg-3 mb-4">
              <div className="card catalogue-card newflyer-card">
                <Link to={item.urlPath} className="catalogue-img">
                  <ImageWithDefault
                    src={"https://cdn.wes.com.au/prodimages" + item.imageFile}
                    alt={item.categoryName}
                    classList="w-100"
                  />
                </Link>
                <div className="card-body">
                  <h5 className="card-title">
                    <Link to={item.urlPath}>
                      {String(item.categoryName || "").length > 52
                        ? `${String(item.categoryName).slice(0, 52)}...`
                        : item.categoryName}
                    </Link>
                  </h5>
                  <p className="card-text">
                    <span className="newFlyer-date">{item.modifiedDate}</span>
                    <span>{item.categoryId}</span>
                  </p>
                  <div className="wesFlyer-btns mt-0 mb-2">
                    <ViewPdfButton item={item} />
                    <ViewEbookButton item={item} />
                  </div>
                  <BrowseOnlineButton item={item} />
                </div>
              </div>
            </div>
          ) : (
            <div className="col-md-12 mb-3">
              <div className="card catalogue-card newFlyer-row">
                <div className="newFlyer-rowImg">
                  <Link to={item.urlPath} className="catalogue-img">
                    <ImageWithDefault
                      src={"https://cdn.wes.com.au/prodimages" + item.imageFile}
                      alt={item.categoryName}
                      classList="w-100"
                    />
                  </Link>
                  <div className="wesFlyerDetails-title">
                    <h5 className="card-title">
                      <Link to={item.urlPath}>
                        {String(item.categoryName || "").length > 52
                          ? `${String(item.categoryName).slice(0, 52)}...`
                          : item.categoryName}
                      </Link>
                    </h5>
                    <p className="card-text">
                      <span className="newFlyer-date">{item.modifiedDate}</span>
                      <span>{item.categoryId}</span>
                    </p>
                  </div>
                </div>
                <div className="card-body wesFlyerDetails-bodyCard">
                  <div className="wesFlyer-btns">
                    <ViewPdfButton item={item} />
                    <ViewEbookButton item={item} />
                  </div>
                  <BrowseOnlineButton item={item} />
                </div>
              </div>
            </div>
          ),
        )}
    </div>
  );
};
